export const getPermissions = () => {
  try {
    return JSON.parse(localStorage.getItem('permissions') || '{}');
  } catch {
    return {};
  }
};

export const getPermissionKeys = (menuCode) => {
  if (!menuCode) return [];

  const cleanKey = String(menuCode).trim().replace(/^\//, '');
  const underscoreKey = cleanKey.replace(/-/g, '_');
  const dashKey = cleanKey.replace(/_/g, '-');
  const upperUnderscoreKey = underscoreKey.toUpperCase();

  return [...new Set([
    cleanKey,
    cleanKey.toLowerCase(),
    underscoreKey,
    underscoreKey.toLowerCase(),
    dashKey,
    dashKey.toLowerCase(),
    upperUnderscoreKey,
  ])];
};

export const getPermission = (menuCode) => {
  const permissions = getPermissions();
  return getPermissionKeys(menuCode)
    .map((key) => permissions[key])
    .find(Boolean);
};

export const hasPermission = (menuCode, action) => {
  const menuPermission = getPermission(menuCode);
  
  if (!menuPermission) return false;
  
  const actionMap = {
    create: 'can_create',
    read: 'can_read',
    update: 'can_update',
    delete: 'can_delete',
    approve: 'can_approve',
    import: 'can_import'
  };
  
  return menuPermission[actionMap[action]] === true;
};

export const canCreate = (menuCode) => hasPermission(menuCode, 'create');
export const canRead = (menuCode) => hasPermission(menuCode, 'read');
export const canUpdate = (menuCode) => hasPermission(menuCode, 'update');
export const canDelete = (menuCode) => hasPermission(menuCode, 'delete');
export const canApprove = (menuCode) => hasPermission(menuCode, 'approve');
export const canImport = (menuCode) => hasPermission(menuCode, 'import');
